import { Reducer } from 'redux'
import { LeadsActionTypes } from '../actions/leads.action'
import { initialLeadsStoreState, LeadsStoreModel } from '../store.model'

export const leadsReducer: Reducer<LeadsStoreModel> = (state = initialLeadsStoreState, action) => {
  switch (action.type) {
    case LeadsActionTypes.STORE_LEADS_SEARCH_MODE:
      return { ...state, searchMode: action.payload }
    case LeadsActionTypes.STORE_LEADS_SEARCHFILTERS:
      return { ...state, leadsSearchFilters: action.payload }
    case LeadsActionTypes.STORE_LEADS_DATATABLE:
      return { ...state, leadsDataTable: action.payload }
    default:
      return state
  }
}
